const validate = values => {
	const errors = {}
	if (!values.state_id) {
		errors.state_id = 'Este campo es obligatorio'
	}
	if (!values.form_locality) {
		errors.form_locality = 'Este campo es obligatorio'
	}
	if (!values.zip_code) {
		errors.zip_code = 'Este campo es obligatorio'
	}
	if (!values.address_street) {
		errors.address_street = 'Este campo es obligatorio'
	}
	return errors
}

export default validate


/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsAddressForm.js
 **/